// extracted by mini-css-extract-plugin
export default {"loader-container":"Loader_loader-container__5hP8V","loader-bar":"Loader_loader-bar__4mXF5","progressAnimation":"Loader_progressAnimation__rJ-3k"};